import { Icon } from "ant-design-vue";

export const admin_icon = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4221832_1iqi7nxho3z.js",
});
